export default {
  CustomerContactClickable: true,
  CustomerContactCopyable: true,
  newPromotion: true,
  pakistanLeader: true,
};
